<template>
    <div class="card shadow-lg mb-5 border border-danger" v-show="$route.name !== 'gym.live' && livestreamOnline">
        <div class="card-body">
            <div class="row">
                <div class="col-md-1">
                    <i class="mdi mdi-record-circle-outline mdi-48px text-danger shaky"></i>
                </div>

                <div class="col-md-11">
                    <p>
                        <span class="text-danger font-weight-bolder">[LIVE]</span>
                        {{ $t('live.alert') }}
                    </p>
                    <router-link tag="button" class="btn btn-dark btn-sm" :to="{name: 'gym.live'}">
                        {{ $t('live.watch_now') }}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LivestreamAlert",
    computed: {
        livestreamOnline() {
            return this.$store.state.settings.livestream_online;
        }
    }
}
</script>

<style scoped>

</style>
